import { useEffect, useState } from "react";
import { Container, Card, Placeholder } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchShopProduct } from "../actions/shopActions";
import { RootState } from "../reducers";
import ProductButtonsBuy from "./ProductButtonsBuy";
import ProductCarousel from "./ProductCarousel";
import { useParams } from "react-router-dom";
import { ProductTag } from "../actions/enums";
import { formatPrice } from "./utilities";



const Product = () => {
  const { productId }: any = useParams();
  const [selectedVariantId, setSelectedVariantId] = useState<number | null>(null);
  const product = useSelector(
    (state: RootState) => state.shop.product[productId]
  );
  const pathImages = useSelector(
    (state: RootState) => state.shop.pathImages[productId]
  );
  const isLoading = useSelector((state: RootState) => state.shop.isLoading);
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(fetchShopProduct(productId));
  }, [productId, dispatch]);

  useEffect(() => {
    setSelectedVariantId(null);
  }, [productId]);

  // Product used for display: resolved variant (when selected) or base product.
  // Falls back to the base product while the variant data is still loading.
  const displayId = selectedVariantId ?? Number(productId);
  const displayProduct = useSelector(
    (state: RootState) => state.shop.product[displayId]
  ) ?? product;

  const discountPercentage =
    !isLoading && displayProduct
      ? Math.ceil(
          ((Number(displayProduct.price_regular) - Number(displayProduct.price)) /
            Number(displayProduct.price_regular)) *
            100
        )
      : 0;

  const displayTypes = displayProduct?.types?.length
    ? displayProduct.types
    : product?.types;

  const hasSales =
    !isLoading && displayProduct
      ? displayTypes?.some((type: any) => type.name === ProductTag.HOT_SALE)
      : false;

  const style = {
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    color: "#000",
    textDecoration: "none",
  };

  return !isLoading && displayProduct ? (
    <Container>
      <h1 className="page-header">{displayProduct.name}</h1>
      <div className="row">
        <div className="col-lg-8 mb-2">
          {pathImages?.length > 0 && (
            <ProductCarousel pathImages={pathImages} />
          )}
        </div>
        <div className="col-lg-4">
          <Card
            className="card-outline-secondary text-center mb-2"
            style={style}
          >
            <Card.Body>
              <Card.Title>{displayProduct.name}</Card.Title>
              {discountPercentage > 1 && (
                <Card.Text className="small text-decoration-line-through mb-0 fw-lighter text-body-secondary">
                  ${formatPrice(displayProduct.price_regular)}
                </Card.Text>
              )}
              <Card.Title className="d-flex flex-row justify-content-center">
                <span>${formatPrice(displayProduct.price)}</span>
                {discountPercentage > 1 && (
                  <span
                    className="small m-1"
                    style={{ fontSize: "14px", color: "rgb(0, 166, 80)" }}
                  >
                    {discountPercentage}% OFF
                  </span>
                )}
              </Card.Title>
              <Card.Text>{displayProduct.description}</Card.Text>
              {hasSales && (
                <span className="small m-1">
                  *Los productos en Hot Sale solo tienen cambio por falla.
                </span>
              )}
            </Card.Body>
            <Card.Footer className="bg-transparent">
              <ProductButtonsBuy
                productId={Number(productId)}
                onResolvedProductChange={setSelectedVariantId}
              />
            </Card.Footer>
          </Card>
        </div>
      </div>
    </Container>
  ) : (
    <Container>
      <Placeholder as="h1" animation="glow" className="page-header mb-4 mt-3">
        <Placeholder xs={6} />
      </Placeholder>
      <div className="row">
        <div className="col-lg-8 mb-2">
          <div style={{ height: '500px', backgroundColor: '#e9ecef', borderRadius: '.25rem' }} className="placeholder-glow w-100">
            <span className="placeholder w-100 h-100"></span>
          </div>
        </div>
        <div className="col-lg-4">
          <Card className="card-outline-secondary text-center mb-2" style={style}>
            <Card.Body>
              <Placeholder as={Card.Title} animation="glow">
                <Placeholder xs={8} />
              </Placeholder>
              <Placeholder as={Card.Title} animation="glow" className="mt-3">
                <Placeholder xs={4} size="lg" />
              </Placeholder>
              <Placeholder as={Card.Text} animation="glow" className="mt-4 text-start">
                <Placeholder xs={12} />
                <Placeholder xs={12} />
                <Placeholder xs={8} />
              </Placeholder>
            </Card.Body>
            <Card.Footer className="bg-transparent pb-4">
              <Placeholder.Button variant="dark" xs={12} className="py-2" />
            </Card.Footer>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default Product;
